import * as React from 'react';
import { useNavigate, useLocation } from "react-router-dom";

import { Button, KIND, SHAPE } from "baseui/button";



export function NavigationButton({ href, children, title }) {
    const currentLocation = useLocation();
    const navigate = useNavigate();

    function isCurrent(url) {
        return currentLocation.pathname.startsWith(url);
    }

    return (
        <>
            {isCurrent(href) ?

                (<Button onClick={() => navigate(href)}  shape={SHAPE.circle}  kind='tertiary'
                    overrides={{
                        BaseButton: {
                            style: ({ $theme }) => ({
                                backgroundColor: $theme.colors.accent100,
                                color:  $theme.colors.accent,
                            })
                        }
                    }}>
                    {children}
                </Button>)
                :
                (<Button   onClick={() => navigate(href)}  shape={SHAPE.circle} kind={KIND.tertiary}  >
                    {children}
                </Button>)
            }
        </>
    )


}